import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
	HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PostInterceptorService } from '../services/post-interceptor/services/post-interceptor.service';

export interface PostResponse {
	status: number;
}

@Injectable()
export class PostInterceptor implements HttpInterceptor {
	constructor(private postService: PostInterceptorService) {}

	intercept(
		request: HttpRequest<unknown>,
		next: HttpHandler
	): Observable<HttpEvent<unknown>> {
		return next.handle(request).pipe(
			map((response) => {
				if (['POST', 'PUT'].includes(request.method)) {
					if (response instanceof HttpResponse) {
						this.postService.setBtSalvarStatus(true);
					}
				}
				return response;
			})
		);
	}
}
